import { PERMISSIONS } from 'interfaces/permissions/permissions'

const BASE_PATH = '/data-sentry'
const withBase = (subPath: string) => `${BASE_PATH}${subPath}`

export const dataSentry = {
  root: {
    path: BASE_PATH,
    pattern: BASE_PATH,
    getURL: () => BASE_PATH,
    permissions: [PERMISSIONS.SENTRY_READ],
  },
  overview: {
    path: 'overview',
    pattern: withBase('/overview'),
    getURL: () => withBase('/overview'),
    permissions: [PERMISSIONS.SENTRY_READ],
  },
  systems: {
    path: 'systems',
    pattern: withBase('/systems'),
    getURL: () => withBase('/systems'),
    permissions: [PERMISSIONS.SENTRY_READ],
  },
  data: {
    path: 'data',
    pattern: withBase('/data'),
    getURL: () => withBase('/data'),
    permissions: [PERMISSIONS.SENTRY_READ],
  },
  trackers: {
    path: 'trackers',
    pattern: withBase('/trackers'),
    getURL: () => withBase('/trackers'),
    permissions: [PERMISSIONS.SENTRY_READ],
  },
}
